import { useEffect, useState } from 'react';
import { fetchAccountFreshness } from '../api/endpointsBackend';

/**
 * Each account's statement freshness, `Map(account_id → row)`, as the
 * Statements page computes it. Empty while loading, when `enabled` is false
 * (the member cannot read files) or when the request fails: the rows then say
 * what they said before.
 */
export default function useAccountFreshness(enabled) {
  const [freshness, setFreshness] = useState(() => new Map());
  useEffect(() => {
    if (!enabled) return undefined;
    let active = true;
    fetchAccountFreshness()
      .then((data) => {
        if (active) setFreshness(new Map((data?.accounts || []).map((a) => [a.account_id, a])));
      })
      .catch(() => {});
    return () => { active = false; };
  }, [enabled]);
  return freshness;
}
